<template>
  <div>
    <b-alert v-if='err' show variant="danger">
      <h4 class="alert-heading"> {{$t('stock.fault.error')}} </h4>
      <hr>
      <p>  {{$t('stock.fault.errorMsg')}} </p>
    </b-alert>

    <validation-observer ref="fsTracking">
      <b-form class="formBox">
        <validation-provider
          :name="$t('stock.fault.no')"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-row>
            <label class="w-100 text-left ml-4" for="tracking-num">{{$t('stock.fault.no')}}</label>
            <b-col md="8" sm="12">
              <b-form-input
                id="tracking-num"
                v-model="fsNo"
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
              />
              <b-form-invalid-feedback tracking-num="live-feedback">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-col>
            <b-col md="4" sm="12">
              <b-button variant="primary" class="w-100" :disabled='isLoading' @click="handleForm">{{$t('stock.fault.check')}}</b-button>
            </b-col>
          </b-row>
        </validation-provider>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fsNo: null,
      err: false
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters.getStockLoading
    },
    fault() {
      return this.$store.getters.faultTracking
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    handleForm() {
      this.$refs.fsTracking.validate().then(async success => {
        if (!success) return
        this.err = false
        await this.$store.dispatch('fetchFaultTracking', this.fsNo)
        if(!Object.keys(this.fault).length) return this.err = true
      })
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/components/FaultSupportTrackingForm.vue